import React from 'react';
import { Switch, Route } from 'react-router-dom';
import asyncComponent from '../../helpers/AsyncFunc';
// import getDevRouters from '../../customApp/router';
import Dashboard from '../Dashboard/index';
class AppRouter extends React.Component {
  render() {
    const { url } = this.props;
    return (
      <Switch>
        <Route
          exact
          path={`${url}/`}
          component={asyncComponent(() => Dashboard)}
        />
    
        {/* {getDevRouters(url)} */}
      </Switch>
    );
  }
}

export default AppRouter;



// WEBPACK FOOTER //
// ./src/containers/App/AppRouter.js